enum WebfitSupportedUnitsEnum {
  Imperial = 'imperial',
  Metric = 'metric',
}

export default WebfitSupportedUnitsEnum;
